module.exports = __webpack_public_path__ + "img/number_of_samples.2305aaa1.svg";